import React from 'react'

const DelayCertificateOverview = () => (
  <section className="d-Delay-section">
    <h2 className="d-Delay-sectionTitle">遅延証明書概要</h2>
    <ul className="d-Delay-sectionList">
      <li className="d-Delay-sectionListItem">
        当証明書の発行は始発から24時頃までといたします。
      </li>
      <li className="d-Delay-sectionListItem">
        当証明書は相鉄線の運行に5分程度以上の遅延が発生したときに発行いたします。
      </li>
      <li className="d-Delay-sectionListItem">
        当証明書の掲載は遅延時間当日から7日間といたします。
      </li>
    </ul>
  </section>
)

export default DelayCertificateOverview